import React from 'react'
import { graphql, Link } from 'gatsby'
import {getPageUrl} from '../lib/helpers'

import * as styles from './article-wrapper.module.css'

const ArticleWrapper = ({article, children}) => {
  return (
        <div className={styles.root}>
            <div className={styles.main}>{children}</div>
            <div className={styles.rightPanel}>
              <div className={styles.stickableArea}>
                <div className={styles.stickyMenu}>
                    <div dangerouslySetInnerHTML={{ __html: `
                      <!-- Ezoic - sidebar - sidebar -->
                      <div id="ezoic-pub-ad-placeholder-101"> </div>
                      <!-- End Ezoic - sidebar - sidebar -->
                      `}}/>
                    <div dangerouslySetInnerHTML={{ __html: `
                      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4556132808286686" crossorigin="anonymous"></script>
                      <!-- side-top -->
                      <ins class="adsbygoogle"
                            style="display:block"
                            data-ad-client="ca-pub-4556132808286686"
                            data-ad-slot="1676918912"
                            data-ad-format="auto"
                            data-full-width-responsive="true"></ins>
                      <script>
                            (adsbygoogle = window.adsbygoogle || []).push({});
                      </script>`}}/>
              
                  { article.keyphrases && article.keyphrases.length > 0 &&
                  <div>
                    <p className={styles.rightSubmenu}>Related Topics</p>
                    <ul className={styles.relatedTopics}>
                    {article.keyphrases.map(topic => topic && (
                        <li key={`topic_${topic.id}`} className={styles.listItem}>
                          {topic.keyphrase}
                        </li>
                    ))}
                    </ul>
                  </div>
                  }

                  { article.related_pages && article.related_pages.length > 0 &&
                  <div>
                    <p className={styles.rightSubmenu}>Similar Pages</p>
                    <ul className={styles.similarPages}>
                    {article.related_pages.map(post => post && (
                        <li key={`similar_${post.id}_${post.slug}`} className={styles.listItem}>
                          <Link to={getPageUrl(post)}>{post.title}</Link>
                        </li>
                    ))}
                    </ul>
                  </div>
                  }

                  <div dangerouslySetInnerHTML={{ __html: `
                      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4556132808286686" crossorigin="anonymous"></script>
                      <!-- side-bottom -->
                      <ins class="adsbygoogle"
                            style="display:block"
                            data-ad-client="ca-pub-4556132808286686"
                            data-ad-slot="9508658542"
                            data-ad-format="auto"
                            data-full-width-responsive="true"></ins>
                      <script>
                            (adsbygoogle = window.adsbygoogle || []).push({});
                      </script>`}}/>
                    <div dangerouslySetInnerHTML={{ __html: `
                      <!-- Ezoic - sidebar_middle - sidebar_middle -->
                      <div id="ezoic-pub-ad-placeholder-104"> </div>
                      <!-- End Ezoic - sidebar_middle - sidebar_middle -->`}}/>
                </div>
              </div>
            </div>
        </div>
  )
}

export default ArticleWrapper
